export var MARKETING_AND_ANALYTICS_CATEGORIES = [
    'A/B Testing',
    'Analytics',
    'Attribution',
    'Email',
    'Enrichment',
    'Heatmaps & Recordings',
    'Raw Data',
    'Realtime Dashboards',
    'Referrals',
    'Surveys',
    'Video'
];
export var ADVERTISING_CATEGORIES = ['Advertising', 'Tag Managers'];
export var FUNCTIONAL_CATEGORIES = [
    'CRM',
    'Customer Success',
    'Deep Linking',
    'Helpdesk',
    'Livechat',
    'Performance Monitoring',
    'Personalization',
    'SMS & Push Notifications',
    'Security & Fraud'
];
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2F0ZWdvcmllcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb25zZW50LW1hbmFnZXIvY2F0ZWdvcmllcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxrQ0FBa0MsR0FBRztJQUNoRCxhQUFhO0lBQ2IsV0FBVztJQUNYLGFBQWE7SUFDYixPQUFPO0lBQ1AsWUFBWTtJQUNaLHVCQUF1QjtJQUN2QixVQUFVO0lBQ1YscUJBQXFCO0lBQ3JCLFdBQVc7SUFDWCxTQUFTO0lBQ1QsT0FBTztDQUNSLENBQUE7QUFFRCxNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBRyxDQUFDLGFBQWEsRUFBRSxjQUFjLENBQUMsQ0FBQTtBQUVyRSxNQUFNLENBQUMsSUFBTSxxQkFBcUIsR0FBRztJQUNuQyxLQUFLO0lBQ0wsa0JBQWtCO0lBQ2xCLGNBQWM7SUFDZCxVQUFVO0lBQ1YsVUFBVTtJQUNWLHdCQUF3QjtJQUN4QixpQkFBaUI7SUFDakIsMEJBQTBCO0lBQzFCLGtCQUFrQjtDQUNuQixDQUFBIn0=